<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("role", 2) }}</div>
      <div>
        <router-link
          class="btn-blue"
          v-if="
            tableId != 1 &&
            tableId != 2 &&
            tableId != 3 &&
            tableId != 4 &&
            tableId != 5 &&
            tableId != 6 &&
            tableId != 7 &&
            tableId != 8 &&
            tableId != 9 &&
            tableId != 10
          "
          @click.native="goToRoute('/user-management/edit-role')"
          to
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="roles"
          >{{ $tc("role", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div
            v-for="(item, index) in Roles"
            :key="index"
            v-if="item.fieldname !== 'role_id'"
            :class="['col-md-12 py-2 ']"
          >
            <!-- , index !== Roles.length -1 ? 'border-bottom': '' -->
            <span v-if="login_user_role_id === 1">
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
            </span>

            <div
              class="row border-bottom"
              v-if="
                item.fieldname !== 'role_id' &&
                item.fieldname !== 'created_at' &&
                item.fieldname !== 'created_by' &&
                item.fieldname !== 'updated_by' &&
                item.fieldname !== 'updated_at'
              "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>

        <!-- ------------------------------------------------------- -->
            <!-- <div v-for="mod in modules" :key="mod.module_category_id" class="mt-4">
              <div
                class="section-title section-border module-title mb-3 d-flex justify-content-between"
                v-b-toggle="`collapse-${mod.module_category_id}`"
              >
               {{ mod.module_name }}
                <button type="button" class="btn-transparent chevron">
                  <img
                    src="@/assets/img/icons/primary/chevron-down.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
              <b-collapse :id="`collapse-${mod.module_category_id}`">
                <table class="list-view-table">
                  <thead>
                    <tr>
                      <th class="th-text">Module</th>
                      <th class="th-text d-flex">
                        <b-form-checkbox
                          class="j-checkbox"
                          v-model="mod.view"
                          @change="selectAllPermissions(mod)"
                          ></b-form-checkbox
                        ><p class="mb-0 mt-n1">View</p>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(mod1, moduleIndex1) in mod.modules"
                      :key="moduleIndex1"
                    >
                      <td>{{ mod1.module_name }}</td>
                      <td>
                        <b-form-checkbox
                          class="j-checkbox"
                          v-model="mod1.view"
                          value="Y"
                          unchecked-value="N"
                          @change="editEditPermission(mod1, 1)"
                          >&nbsp;</b-form-checkbox
                        >
                      </td>
                    <td></td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Roles from "@/helper/formJSONMaster/Roles";
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      login_user_role_id: null,
      tableId: null,
      accessLevels: ["View application Information", true, false],
      modules: [],
      ro_id: "",
      cRoleName: "",
      Roles: [
        ...Roles.ms_roles,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: "123456",
          type: "text",
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: true,
          type: "text",
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: true,
          type: "text",
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: true,
          type: "text",
        },
      ],

      Methods: Roles.Methods,
      submitted: false,
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.ro_id = id;
      this.tableId = id;
      this.getViewList(id);
    } else {
      this.$router.go(-1);
    }

    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      console.log("collapseId:", collapseId);
      console.log("isJustShown:", isJustShown);
    });
   // this.getModuleList();
  },
  methods: {
    onClick(e) {
      console.log("e :>> ", e);

      this.modules = this.modules.map((m) => {
        if (m.module_category_id == e) {
          return {
            ...m,
            show: !m.show,
          };
        } else {
          return m;
        }
      });
    },
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId,
        },
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getModuleList: function () {
      let loader = this.$loading.show();
      let payload = {
        role_id: this.ro_id,
      };
      UserService.ListAllModules(payload)
        .then((response) => {
          loader.hide();
          const { data } = response;
          if (data.status) {
            this.modules = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    selectAllPermissions(mod) {
      const [getModule] = this.modules.filter(
        (f) => f.module_category_id == mod.module_category_id
      );
      if (!mod.view) {
        getModule.modules.forEach((f) => {
          f.view = "Y";
          this.editEditPermission(f, 1);
        });
      } else {
        getModule.modules.forEach((f) => {
          f.view = "N";
          this.editEditPermission(f, 1);
        });
      }
    },
    editEditPermission: function (mod, accessType) {
      let payload = {
        role_id: this.ro_id,
        module_id: mod.module_id,
        access_id: accessType,
        mod,
      };
      UserService.EditPerma(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.$toasted.show("User Permission updated successfully");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Roles.map((x, index) => {
              if (x.fieldname === "created_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "Roles");
              } else if (x.fieldname === "updated_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "Roles");
              } else if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getViewUsersDetails(user_id, index, key) {
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
  },
};
</script>

<style scoped>
/* table {
  border-collapse: collapse;
  width: 100%;
}
th {
  text-align: left;
}
td {
  border-bottom: 1px solid #dddddd;
  text-align: left;
} */
/*
td:nth-child(1) {
  width: 30%;
} */
/* td:nth-child(3){
   width:auto
 }
 .collapse{
   width: inherit;
 }
.collapse>tr>td{
  text-align: left;
} */
.module-title {
 cursor: pointer;
 /* font-size: 12px; */
}
.th-text {
 font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/Roles/RoleDetails.vue